export const MUNICIPI = [
    {
      "label": "Municipio 1 (Murat, San Nicola, Libertà, Madonnella, Japigia, Torre a mare)",
      "value": "1"
    },
    {
      "label": "Municipio 2 (Poggiofranco, Picone, Carrassi, San Pasquale, Mungivacca)",
      "value": "2"
    },
    {
      "label": "Municipio 3 (San Paolo, Stanic, Marconi, San Girolamo, Fesca, Villaggio del Lavoratore)",
      "value": "3"
    },
    {
      "label": "Municipio 4 (Carbonara, Ceglie, Loseto)",
      "value": "4"
    },
    {
      "label": "Municipio 5 (Palese, Santo Spirito, Catino, San Pio)",
      "value": "5"
    }
];